import { gql } from "@apollo/client";

export const TOGGLE_DOCUMENT_SELECTION = gql`
  mutation ToggleDocumentSelection($documentId: ID!, $isActive: Boolean!) {
    toggleDocumentSelection(documentId: $documentId, isActive: $isActive) {
      id
      documentId
      isActive
    }
  }
`;

export const BULK_TOGGLE_DOCUMENT_SELECTIONS = gql`
  mutation BulkToggleDocumentSelections($documentIds: [ID!]!, $isActive: Boolean!) {
    bulkToggleDocumentSelections(documentIds: $documentIds, isActive: $isActive) {
      id
      documentId
      isActive
    }
  }
`; 